import { getLoggerCurrentLevelUrl } from "config/paths";

export default token => {
  const fetchOptions = {
    method: "GET",
    mode: "cors",
  };

  return fetch(getLoggerCurrentLevelUrl(token), fetchOptions).then(res => {
    if (res.ok) {
      return res.text();
    }
    throw new Error();
  });
};
